import { ENV } from "../utils/constants";
import api from "./api";
import { RespGetDesempenhoEnvioGeralWhats, RespGetDesempenhoEnvioMesWhats } from "../types/whatsapp";

export const getGraphsWhatsapp = async (): Promise<any[]> => {
  const params = {
    status_type: "WHATSAPP",
  };

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/campaigns-status-by-semester`,
    { params }
  );

  return data?.content;
};


export const getDesempenhoEnvioGeralWhatsapp = async (): Promise<RespGetDesempenhoEnvioGeralWhats> => {
  const params = {
    tipoCampanha: "WHATSAPP",
  };

  const { data } = await api.get(
    `/insights-p2-${ENV}/${ENV}/crm/insights/getDesempenhoEnvioGeral`,
    { params }
  );
  return data;
};

export const getDesempenhoEnvioGroupedMesWhatsapp = async (): Promise<RespGetDesempenhoEnvioMesWhats> => {
  const params = {
    tipoCampanha: "WHATSAPP",
  };

  const { data } = await api.get(
    `/insights-p2-${ENV}/${ENV}/crm/insights/getDesempenhoEnvioGroupedMonth`,
    { params }
  );
  return data;
};